module.exports = __webpack_public_path__ + "img/20200922_093331.7d8fe893.jpg";